import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { Button, Card, Col, Form, Icon, Input, Row, Typography } from 'antd';

import { performPasswordReset } from '../../redux/auth';

const ResetPassword = ({ performPasswordReset }) => {
  const [form] = Form.useForm();
  const [token, setToken] = useState('');

  useEffect(() => {
    const usp = new URLSearchParams(window.location.search);
    setToken(usp.get('token') || '');
  }, []);

  const passwordRules = useMemo(
    () => [
      { required: true, message: 'Введите новый пароль' },
      // {
      //   validator: (_, value) => {
      //     if (!value) return Promise.resolve();
      //     const hasLen = value.length >= 8;
      //     const hasLower = /[a-z]/.test(value);
      //     const hasUpper = /[A-Z]/.test(value);
      //     const hasDigit = /\d/.test(value);
      //     const hasSpecial = /[#@$%^&*()_\-+=[\]{};':"\\|,.<>/?~]/.test(value);
      //     return hasLen && hasLower && hasUpper && hasDigit && hasSpecial
      //       ? Promise.resolve()
      //       : Promise.reject(
      //           new Error(
      //             'Пароль должен быть ≥ 8 символов и содержать строчные/прописные буквы, цифры и спецсимвол.'
      //           )
      //         );
      //   },
      // },
    ],
    []
  );

  const onFinish = async (values) => {
    if (!token) {
      alert('Некорректная ссылка для сброса (нет токена). Запросите сброс ещё раз.');
      return;
    }
    const ok = await performPasswordReset(token, values.password);
    if (ok) {
      window.location.assign('/signin');
    } else {
      alert('Не удалось сбросить пароль. Попробуйте позже.');
    }
  };

  return (
    <Row style={{ paddingTop: 200 }}>
      <Col span={6} offset={9}>
        <Card>
          <div style={{ textAlign: 'center', marginBottom: 16 }}>
            <Typography.Title level={3} style={{ marginBottom: 0, color: '#fff' }}>
              Новый пароль
            </Typography.Title>
            <Typography.Text type="secondary" style={{ marginBottom: 0, color: '#fff' }}>
              Придумайте новый пароль и подтвердите его
            </Typography.Text>
          </div>

          <Form form={form} onFinish={onFinish} autoComplete="off" layout="vertical">
            <Form.Item name="password" label="Пароль" rules={passwordRules} hasFeedback>
              <Input.Password
                size="large"
                placeholder="Не менее 8 символов"
                autoComplete="new-password"
                prefix={<Icon type={'LockOutlined'} style={{ color: 'rgba(0,0,0,.25)' }} />}
              />
            </Form.Item>

            <Form.Item
              name="confirm"
              label="Подтверждение пароля"
              dependencies={['password']}
              hasFeedback
              rules={[
                { required: true, message: 'Подтвердите пароль' },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('password') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('Пароли не совпадают'));
                  },
                }),
              ]}
            >
              <Input.Password
                size="large"
                placeholder="Повторите пароль"
                autoComplete="new-password"
                prefix={<Icon type={'LockOutlined'} style={{ color: 'rgba(0,0,0,.25)' }} />}
              />
            </Form.Item>

            <Button type="primary" htmlType="submit" size="large" block>
              Сохранить пароль
            </Button>

            <Button
              style={{ marginTop: 8 }}
              size="large"
              block
              onClick={() => (window.location.href = '/signin')}
            >
              Перейти ко входу
            </Button>
          </Form>
        </Card>
      </Col>
    </Row>
  );
};

export default connect(null, { performPasswordReset })(ResetPassword);
